<template>
  <el-row :gutter="20">
    <el-col :span="11" class="transfer-wrap">
      <el-row class="transfer-title" :gutter="20">
        <el-col :span="18">
          <div class="grid-content bg-purple">{{ leftTitle }}</div>
        </el-col>
        <el-col :span="6"></el-col>
      </el-row>
      <el-row class="transfer-con">
        <el-checkbox-group v-model="selectForm">
          <el-checkbox-button
            v-for="item in leftList"
            :label="item[listId]"
            :key="item[listId]"
            >{{ item[listName] }}</el-checkbox-button
          >
        </el-checkbox-group>
      </el-row>
    </el-col>
    <el-col :span="2" style="height:460px">
      <div class="transfer-buttons">
        <button @click="addRight" style="margin-bottom:40px">
          <span>
            <i class="iconfont icon-right"></i>
          </span>
        </button>
        <button @click="addLeft">
          <span>
            <i class="iconfont icon-right transform"></i>
          </span>
        </button>
      </div>
    </el-col>
    <el-col :span="11" class="transfer-wrap">
      <el-row class="transfer-title" :gutter="20">
        <el-col :span="18">
          <div class="grid-content bg-purple">{{ rightTitle }}</div>
        </el-col>
        <el-col :span="6"></el-col>
      </el-row>
      <el-row class="transfer-con">
        <el-checkbox-group v-model="unselectForm">
          <el-checkbox-button
            v-for="item in rightList"
            :label="item[listId]"
            :key="item[listId]"
            >{{ item[listName] }}</el-checkbox-button
          >
        </el-checkbox-group>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "UserTransfer",
  props: {
    leftList: {
      type: Array,
      default: () => [],
      required: true,
    },
    rightList: {
      type: Array,
      default: () => [],
      required: true,
    },
    listName: {
      type: String,
      required: true,
    },
    listId: {
      type: String,
      required: true,
    },
    leftTitle: {
      type: String,
      required: true,
    },
    rightTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectForm: [],
      unselectForm: [],
    }
  },
  methods: {
    addRight() {
      if (this.selectForm.length == 0) {
        return
      }
      this.$emit("clickRight", this.selectForm)
      this.selectForm = []
    },
    addLeft() {
      if (this.unselectForm.length == 0) {
        return
      }
      this.$emit("clickLeft", this.unselectForm)
      this.unselectForm = []
    },
  },
}
</script>

<style lang="scss" scoped>
.transfer-wrap {
  height: 460px;
  font-size: 14px;
  border: 1px solid #ccc;
}
.transfer-title {
  margin: 0px !important;
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
  color: #333;
  background: #f4f4f4;
}
.transfer-con {
  height: 418px;
  overflow: auto;
  padding: 10px 43px;
}
.transfer-con /deep/ .el-checkbox-group {
  width: 420px;
  height: 100%;
  margin: 0 auto;
}
.transfer-con /deep/ .el-checkbox-button__original {
  left: 0;
}
.transfer-con /deep/ .el-checkbox-button__inner {
  width: 100%;
  height: 100%;
  float: left;
  line-height: 30px;
  padding: 0;
  box-sizing: initial;
  border: 0;
}
.transfer-con
  /deep/
  .el-checkbox-button:first-child
  .el-checkbox-button__inner {
  border: 0;
}
.transfer-con /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: #0094ff;
  color: #fff;
  border-color: #0094ff;
}
.transfer-con /deep/ .el-checkbox-button {
  width: 118px;
  height: 30px;
  overflow: hidden;
  line-height: 30px;
  margin: 10px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.transfer-buttons {
  height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.transfer-buttons .iconfont:hover {
  color: #fff;
}
.transfer-buttons .transform {
  transform: rotate(135deg);
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  display: inline-block !important;
}
.transfer-buttons button {
  width: 40px;
  height: 40px;
  color: #fff;
  border: none;
  border-radius: 20px;
  background-color: #0094ff;
  cursor: pointer;
}
.transfer-buttons button:hover {
  background-color: #40afff;
}
.el-col {
  padding: 0 !important;
}
</style>
